import { createI18n } from 'vue-i18n'
import de from './de'
import pl from './pl'
import cz from './cz'

interface LocaleConfiguration {
    shortLocale: string; // Language code (eg en)
    longLocale: string; // Full locale code including language and country (eg en-GB)
    tmsLocales: Array<string>; // locale codes used in TMS
    currency: string; // currency to use for a locale
}

// Helper to escape @ symbol for vue-i18n
function escapeI18nMessages(obj: any): any {
    if (typeof obj === 'string') {
        // Replace @ and | with {'@'} and {'|'} to escape them in vue-i18n
        return obj.replace(/([@|])/g, "{'$1'}");
    }
    if (typeof obj === 'object' && obj !== null) {
        const result: any = Array.isArray(obj) ? [] : {};
        for (const key in obj) {
            result[key] = escapeI18nMessages(obj[key]);
        }
        return result;
    }
    return obj;
}

const messages = escapeI18nMessages({
    de,
    pl,
    cz
});
const defaultLocale = "de";

const i18n = createI18n({
    legacy: true,
    locale: defaultLocale,
    fallbackLocale: defaultLocale,
    messages,
    silentFallbackWarn: true,
    silentTranslationWarn: true,
    warnHtmlMessage: false,
    warnHtmlInMessage: 'off'
});

const localeConfiguration: Array<LocaleConfiguration> = [
    {
        shortLocale: "de",
        longLocale: "de-DE",
        tmsLocales: [ "D", "DE"],
        currency: "EUR"
    }, 
    {
        shortLocale: "pl",
        longLocale: "pl-PL",
        tmsLocales: [  "PL" ],
        currency: "PLN"
    }, 
    {
        shortLocale: "cz",
        longLocale: "cs-CZ",
        tmsLocales: [ "CZ" ],
        currency: "CZK"
    }
];

export function resolveTmsLocale(tmsLocaleCode: string): string {
    const matchingLocale = localeConfiguration.find(l => l.tmsLocales.indexOf(tmsLocaleCode) > -1);
    return matchingLocale === undefined? localeConfiguration[0].shortLocale: matchingLocale.shortLocale;
}

export function getLongLocaleCode(shortLocaleCode: string): string {
    const matchingLocale = localeConfiguration.find(l => l.shortLocale === shortLocaleCode);
    return matchingLocale === undefined? localeConfiguration[0].longLocale: matchingLocale.longLocale;
}

export function getLongLocaleCodeMap(shortLocaleCode: string): string {
    if(shortLocaleCode == "cz") return "en-US"; //US 9788
    return getLongLocaleCode(shortLocaleCode);
}

export function getCurrencyCode(tmsLocaleCode: string): string {
    const matchingLocale = localeConfiguration.find(l => l.tmsLocales.indexOf(tmsLocaleCode) > -1);
    return matchingLocale === undefined? localeConfiguration[0].currency: matchingLocale.currency;
}

// Helper to safely get locale with Vue I18n 9 legacy mode
export function getLocale(): string {
    const locale = i18n.global?.locale;
    if (!locale) return 'de';
    return typeof locale === 'string' ? locale : (locale as any).value || 'de';
}

// Helper to safely set locale with Vue I18n 9 legacy mode
export function setLocale(newLocale: string): void {
    if (!i18n.global) return;
    const locale = i18n.global.locale;
    if (typeof locale === 'string') {
        (i18n.global as any).locale = newLocale;
    } else {
        (locale as any).value = newLocale;
    }
}

export default i18n;
